/* Sola Wear — CLEAN cart drawer (overgenomen van Zeyna London, patches 01–03 + 10 + 16).
   Zelfde motor als de drukke cart: direct openen, optimistische wijzigingen
   gebundeld in één /cart/update.js op variant-id, chirurgische DOM-updates.
   Aangepast aan Horizon 4.1.0: de thema-cart is daar een <theme-drawer id="cart-drawer">
   met het <dialog> als OUDER van <cart-drawer-component>, en de pagina wordt vergrendeld
   via lockScroll(owner) → html[scroll-lock] (niet meer via body{position:fixed}). */
(function () {
  'use strict';
  if (window.__ZLCartClean) return;
  if (!window.fetch || !window.fetch.bind) return;
  window.__ZLCartClean = { pending: true };
  // Pas als het script echt draait mag de CSS het thema-dialog verbergen;
  // faalt dit bestand, dan valt de site terug op de gewone thema-cart.
  document.documentElement.classList.add('zlc-on');

  var CFG = window.ZLCC || {};
  var TIERS = CFG.tiers || [];

  // Ruwe fetch vastleggen vóór onze eigen patch.
  var rawFetch = window.fetch.bind(window);

  // Herkent het cart-dialog van het thema. Nesting in Horizon 4.x:
  //   <theme-drawer id="cart-drawer"> <dialog> <cart-drawer-component>
  // Het dialog is dus de OUDER van cart-drawer-component, niet het kind.
  function isThemeCartDialog(d) {
    if (!d || d.tagName !== 'DIALOG') return false;
    try {
      if (d.querySelector('cart-drawer-component')) return true;
      if (d.closest('#cart-drawer')) return true;
    } catch (e) {}
    return false;
  }

  function isThemeCartDrawer(el) {
    if (!el) return false;
    if (el.id === 'cart-drawer') return true;
    try { return !!el.querySelector('cart-drawer-component'); } catch (e) { return false; }
  }

  // Openen vóór init (bv. auto-open na add-to-cart terwijl de pagina nog laadt): onthouden.
  var openWhenReady = false;
  function requestOpen() {
    if (root) openNow(); else openWhenReady = true;
  }

  // Hoofdroute: de thema-lade van de cart opent nooit meer; open() en toggle() van
  // <theme-drawer id="cart-drawer"> openen onze eigen cart. Op het prototype, zodat het
  // ook werkt als het thema de cart-sectie opnieuw rendert (nieuw element).
  // Zo roept het thema ook nooit lockScroll() aan → de pagina kan niet vastlopen.
  // toggle() opent altijd (nooit sluiten): onze eigen klik-handler heeft dan al geopend.
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('theme-drawer').then(function () {
      var C = customElements.get('theme-drawer');
      if (!C || C.prototype.__zlcPatched) return;
      var P = C.prototype, origOpen = P.open, origToggle = P.toggle;
      P.__zlcPatched = true;
      P.open = function () {
        if (isThemeCartDrawer(this)) { requestOpen(); return; }
        return origOpen.apply(this, arguments);
      };
      P.toggle = function () {
        if (isThemeCartDrawer(this)) { requestOpen(); return; }
        return origToggle.apply(this, arguments);
      };
    }).catch(function () {});
  }

  // Vangnet: opent het thema-cart-dialog tóch (andere route), dan nooit echt tonen en
  // via de lade zelf netjes sluiten, zodat Horizon zijn scroll-lock ook weer loslaat.
  if (window.HTMLDialogElement) {
    ['showModal', 'show'].forEach(function (naam) {
      var orig = HTMLDialogElement.prototype[naam];
      if (!orig) return;
      HTMLDialogElement.prototype[naam] = function () {
        if (isThemeCartDialog(this)) {
          var d = this;
          setTimeout(function () {
            try { d.dispatchEvent(new Event('close')); } catch (e) {}
            closeThemeDialog();
          }, 0);
          return;
        }
        return orig.apply(this, arguments);
      };
    });
  }

  // De cart-knop in de header draagt on:click="#cart-drawer/toggle". Dat attribuut
  // weghalen zodat het thema zijn eigen lade niet via die route opent; onze eigen
  // click-handler blijft gewoon werken.
  function disarmThemeCartTriggers() {
    var nodes;
    try { nodes = document.querySelectorAll('[on\\:click]'); } catch (e) { return; }
    for (var i = 0; i < nodes.length; i++) {
      var val = nodes[i].getAttribute('on:click') || '';
      if (val.indexOf('#cart-drawer') === 0) {
        nodes[i].setAttribute('data-zlc-was', val);
        nodes[i].removeAttribute('on:click');
      }
    }
  }

  var root, ov, drawer, els = {};
  var cart = null;
  var rendered = false;
  var lastFocus = null;
  var cmpCache = {};        // handle -> { variant_id: compare_at_price }
  var noTier = {};          // variant_id -> true als de staffelkorting er niet op valt
  var serverPct = 0;        // staffel die Shopify in de laatste server-cart écht toepaste
  var estimated = false;    // true = bedragen zijn een optimistische schatting (na +/-)
  var cartLevel = 0;        // korting op cartniveau (code), niet in de regels
  var fetchSeq = 0;

  // Wachtrij op variant-id: line-item-keys her-key'en bij elke kortingsgrens.
  var q = { pending: {}, timer: null, inflight: false, dirty: false, last: null, reconciling: false, retried: false };

  function $(s, c) { return (c || root).querySelector(s); }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function money(cents, cur) {
    var c = cur || (cart && cart.currency) || CFG.currency || 'GBP';
    try {
      return new Intl.NumberFormat(CFG.locale || undefined, {
        style: 'currency', currency: c, minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  function img(url, w) {
    if (!url) return '';
    return url.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_' + w + 'x$1$2');
  }

  function getCart() {
    return rawFetch(CFG.routes.cart + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function post(url, body) {
    return rawFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  // Sequence-bewaakte cart-read: oude/kapotte responses winnen nooit.
  function readCart() {
    var my = ++fetchSeq;
    return getCart().then(function (c) {
      if (my !== fetchSeq) return null;
      if (!c || !c.items) return null;
      return c;
    }).catch(function () { return null; });
  }

  function unitOf(it) { return it.original_price != null ? it.original_price : it.price; }

  function totals() {
    var qty = 0;
    (cart && cart.items || []).forEach(function (it) { qty += it.quantity; });
    return { qty: qty };
  }

  // Voet: opgeteld uit dezelfde regelbedragen als de productkaarten, zodat
  // doorgestreept 'was' − 'Total Discounts' altijd precies 'Total' is.
  // Een kortingscode op cartniveau zit alleen in total_price en telt zo mee.
  function footTotals() {
    var was = 0;
    (cart && cart.items || []).forEach(function (it) {
      var m = lineMoney(it);
      was += m.save ? m.was : m.now;
    });
    var now = cart ? cart.total_price : 0;
    return { was: was, now: now, saved: Math.max(0, was - now) };
  }

  function sig(c) {
    var s = String(c.total_price) + '|';
    (c.items || []).forEach(function (it) { s += it.variant_id + ':' + it.quantity + ';'; });
    return s;
  }

  function findByVariant(vid) {
    if (!cart) return null;
    for (var i = 0; i < (cart.items || []).length; i++) {
      if (cart.items[i].variant_id === vid) return cart.items[i];
    }
    return null;
  }

  function rowByVariant(vid) {
    var rows = els.body.querySelectorAll('.zlc-li');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-variant') === String(vid)) return rows[i];
    }
    return null;
  }

  function hasPending() {
    if (q.inflight || q.timer || q.reconciling) return true;
    for (var k in q.pending) return true;
    return false;
  }

  function paintSync(on) {
    ['totNow', 'totWas', 'discVal'].forEach(function (n) {
      if (els[n]) els[n].classList.toggle('zlc-sync', !!on);
    });
  }

  /* Staffelbalk bovenin: alle staffels naast elkaar; de behaalde krijgt een vinkje. */
  function noteHTML() {
    return TIERS.map(function (t) {
      return '<span class="zlc-tier" data-pct="' + t.pct + '">' +
        '<span class="zlc-tier__ic" aria-hidden="true">&#10003;</span>' +
        '<span>Buy ' + t.qty + ': <b>' + t.pct + '% off</b></span></span>';
    }).join('');
  }

  function tierPct(qty) {
    var pct = 0;
    TIERS.forEach(function (t) { if (qty >= t.qty) pct = t.pct; });
    return pct;
  }

  // Staffelkorting actief in deze server-cart? Dan vallen regels zónder
  // korting er niet onder; dat onthouden we voor de optimistische schatting.
  // Sola: de staffel geldt alleen voor bepaalde collecties (niet o.a. laarzen/knitwear),
  // en Shopify telt voor de drempel alleen de producten die meedoen.
  // Geen staffel actief terwijl een regel al ≥ de laagste drempel heeft? Dan doet die niet mee.
  function learnTiers(c) {
    var items = (c && c.items) || [];
    var active = items.some(function (it) { return it.final_line_price < it.original_line_price; });
    if (active) {
      items.forEach(function (it) {
        noTier[it.variant_id] = it.final_line_price >= it.original_line_price;
      });
      return;
    }
    var min = Infinity;
    TIERS.forEach(function (t) { if (t.qty < min) min = t.qty; });
    items.forEach(function (it) { if (it.quantity >= min) noTier[it.variant_id] = true; });
  }

  // Aantal stuks dat (voor zover bekend) meetelt voor de staffel.
  function tierQty() {
    var n = 0;
    (cart && cart.items || []).forEach(function (it) { if (!noTier[it.variant_id]) n += it.quantity; });
    return n;
  }

  // Welke staffel paste Shopify echt toe? (hoogste percentage-korting die een staffel is)
  function appliedPct(c) {
    var pct = 0;
    ((c && c.items) || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var d = a.discount_application || {};
        var v = Math.round(parseFloat(d.value));
        if (d.value_type === 'percentage' && a.amount > 0 &&
            TIERS.some(function (t) { return t.pct === v; }) && v > pct) pct = v;
      });
    });
    return pct;
  }

  // Na een +/- direct de regelprijzen schatten met de staffel; het echte
  // bedrag van Shopify overschrijft dit zodra /cart/update.js terug is.
  function estimateLines() {
    estimated = true;
    var pct = tierPct(tierQty()), sum = 0;
    (cart.items || []).forEach(function (it) {
      var orig = unitOf(it) * it.quantity;
      it.original_line_price = orig;
      it.final_line_price = noTier[it.variant_id] ? orig : Math.round(orig * (100 - pct) / 100);
      sum += it.final_line_price;
    });
    cart.total_price = Math.max(0, sum - cartLevel);
  }

  // Regelbedragen, altijd × aantal: 'now' is wat de klant echt betaalt (na
  // staffelkorting), 'was' de vergelijkprijs × aantal, 'save' het verschil.
  function lineMoney(it) {
    var map = cmpCache[it.handle];
    var cmp = (map && map[it.variant_id]) || 0;
    var orig = unitOf(it) * it.quantity;
    var now = it.final_line_price != null ? it.final_line_price : orig;
    var was = Math.max(cmp * it.quantity, orig);
    return was > now ? { was: was, now: now, save: was - now } : { was: 0, now: now, save: 0 };
  }

  function priceHTML(it) {
    var m = lineMoney(it);
    return (m.save ? '<span class="zlc-li__was">' + money(m.was) + '</span>' : '') +
      '<span class="zlc-li__now">' + money(m.now) + '</span>' +
      (m.save ? '<span class="zlc-li__save">You save ' + money(m.save) + '</span>' : '');
  }

  function paintPrices() {
    if (!cart) return;
    (cart.items || []).forEach(function (it) {
      var row = rowByVariant(it.variant_id);
      var prices = row && row.querySelector('.zlc-li__prices');
      if (!prices) return;
      var html = priceHTML(it);
      if (prices.innerHTML !== html) prices.innerHTML = html;
    });
  }

  function lineHTML(it) {
    var opts = (it.options_with_values || [])
      .filter(function (o) { return o.value && o.value.toLowerCase() !== 'default title'; })
      .map(function (o) {
        return '<span class="zlc-opt">' + (o.name ? '<span class="zlc-opt__n">' + esc(o.name) + ':</span> ' : '') +
          esc(o.value) + '</span>';
      }).join('');

    return '<div class="zlc-li" data-variant="' + it.variant_id + '">' +
      (it.featured_image && it.featured_image.url
        ? '<img class="zlc-li__img" src="' + esc(img(it.featured_image.url, 220)) + '" alt="" loading="lazy" width="72" height="96">'
        : '<span class="zlc-li__img"></span>') +
      '<div class="zlc-li__main">' +
        '<div class="zlc-li__top">' +
          '<p class="zlc-li__t"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p>' +
          '<button type="button" class="zlc-li__rm" data-act="rm" aria-label="Remove item">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13"/></svg>' +
          '</button>' +
        '</div>' +
        (opts ? '<div class="zlc-li__v">' + opts + '</div>' : '') +
        '<div class="zlc-li__prices">' + priceHTML(it) + '</div>' +
        '<div class="zlc-qty">' +
          '<button type="button" data-act="dec" aria-label="Decrease quantity">&minus;</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button type="button" data-act="inc" aria-label="Increase quantity">+</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function renderItems() {
    if (!cart || !cart.items || !cart.items.length) {
      els.body.innerHTML = '<div class="zlc-empty"><p>Your cart is empty. Start with a coat.</p>' +
        '<a href="' + esc(CFG.routes.start || CFG.routes.all || '/collections/all') + '">SHOP COATS &amp; JACKETS</a></div>';
      return;
    }
    els.body.innerHTML = cart.items.map(lineHTML).join('');
  }

  /* Kortingsnamen: Shopify hangt de staffelkorting op regelniveau. */
  function discountTitles() {
    var seen = {}, out = [];
    function add(t) { if (t && !seen[t]) { seen[t] = 1; out.push(t); } }
    if (!cart) return out;
    (cart.cart_level_discount_applications || []).forEach(function (d) { add(d.title); });
    (cart.items || []).forEach(function (it) {
      (it.discounts || []).forEach(function (d) { add(d.title); });
      (it.line_level_discount_allocations || []).forEach(function (a) {
        add(a.discount_application && a.discount_application.title);
      });
    });
    return out;
  }

  function renderFooter() {
    var t = footTotals();
    var qty = totals().qty;

    els.discRow.hidden = t.saved <= 0;
    if (t.saved > 0) els.discVal.textContent = '− ' + money(t.saved);

    els.pills.innerHTML = discountTitles().map(function (title) {
      return '<span class="zlc-pill">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M20.6 13.4 12 22l-9-9V3h10z"/><circle cx="7.5" cy="7.5" r="1.2"/></svg>' +
        esc(title) + '</span>';
    }).join('');

    els.totWas.hidden = t.saved <= 0;
    if (t.saved > 0) els.totWas.textContent = money(t.was);
    els.totNow.textContent = money(t.now);

    els.co.disabled = !qty;
    els.ft.hidden = !qty;
  }

  function paintHeader(qty) {
    els.title.textContent = qty ? 'Your cart (' + qty + (qty === 1 ? ' item)' : ' items)') : 'Your cart';
    // Vinkje = de staffel die echt geldt (server), of tijdens +/- de schatting daarvan.
    var pct = !qty ? 0 : (estimated ? tierPct(tierQty()) : serverPct);
    var tiers = els.note.querySelectorAll('.zlc-tier');
    for (var i = 0; i < tiers.length; i++) {
      tiers[i].classList.toggle('is-on', pct > 0 && tiers[i].getAttribute('data-pct') === String(pct));
    }
  }

  function render() {
    if (!cart) return;
    rendered = true;
    paintHeader(totals().qty);
    renderItems();
    renderFooter();
    fetchCompare();
  }

  // Zelfde regels? Alleen cijfers bijwerken, geen innerHTML-wipe.
  // Zelfde variant op meerdere regels (line-item properties)? Dan is het
  // variant-model niet 1-op-1 en renderen we altijd volledig.
  function hasDupes(c) {
    var seen = {}, items = c.items || [];
    for (var i = 0; i < items.length; i++) {
      if (seen[items[i].variant_id]) return true;
      seen[items[i].variant_id] = 1;
    }
    return false;
  }

  function sameVariantSet(c) {
    if (!rendered) return false;
    var rows = els.body.querySelectorAll('.zlc-li');
    var items = c.items || [];
    if (rows.length !== items.length) return false;
    var have = {};
    items.forEach(function (it) { have[it.variant_id] = (have[it.variant_id] || 0) + 1; });
    for (var i = 0; i < rows.length; i++) {
      var v = rows[i].getAttribute('data-variant');
      if (!have[v]) return false;
      have[v]--;
    }
    return true;
  }

  function syncDOM() {
    var t = totals();
    paintHeader(t.qty);
    (cart.items || []).forEach(function (it) {
      var row = rowByVariant(it.variant_id);
      if (!row) return;
      var span = row.querySelector('.zlc-qty span');
      if (span && span.textContent !== String(it.quantity)) span.textContent = it.quantity;
    });
    paintPrices();
    renderFooter();
    if (!t.qty) renderItems();
  }

  function applyCart(c) {
    var changed = !cart || !rendered || sig(c) !== sig(cart);
    var soft = !hasDupes(c) && sameVariantSet(c);
    cart = c;
    estimated = false;
    serverPct = appliedPct(c);
    learnTiers(c);
    var lines = 0;
    (c.items || []).forEach(function (it) { lines += it.final_line_price; });
    cartLevel = Math.max(0, lines - c.total_price);
    // Ongewijzigd, maar de bedragen kunnen nog een optimistische schatting zijn.
    if (!changed && rendered) { if (soft) { paintHeader(totals().qty); paintPrices(); renderFooter(); } return; }
    if (soft) syncDOM(); else render();
  }

  // Drawer opent DIRECT; verversing loopt op de achtergrond.
  function openNow() {
    show();
    if (cart) { if (!rendered) render(); }
    else if (!els.body.firstElementChild) {
      els.body.innerHTML = '<div class="zlc-empty"><p>Loading your cart&hellip;</p></div>';
    }
    refresh();
  }

  var retryT = null;
  var retryN = 0;

  function showLoadError() {
    if (rendered) return;
    els.body.innerHTML = '<div class="zlc-empty"><p>We couldn&#39;t load your cart.</p>' +
      '<a href="#" data-act="retry">TRY AGAIN</a></div>';
  }

  function refresh() {
    return readCart().then(function (c) {
      if (!c) {
        // Nooit een eeuwige 'Loading…': twee stille herkansingen, daarna een
        // zichtbare foutstaat met een echte uitweg (TRY AGAIN).
        if (!cart) {
          if (retryN < 2 && !retryT) {
            retryN++;
            retryT = setTimeout(function () { retryT = null; refresh(); }, 1500);
          } else if (!retryT && drawer.classList.contains('is-open')) {
            showLoadError();
          }
        }
        return;
      }
      retryN = 0;
      if (hasPending()) return;               // optimistische edits niet overschrijven
      applyCart(c);
    });
  }

  // ---- optimistische hoeveelheid-wijzigingen -------------------------------

  function optimisticQty(vid, qty) {
    var it = findByVariant(vid);
    if (!it) return;
    qty = Math.max(0, qty);
    if (qty === it.quantity && qty !== 0) return;
    it.quantity = qty;
    if (qty === 0) {
      cart.items = cart.items.filter(function (x) { return x.variant_id !== vid; });
    }

    var row = rowByVariant(vid);
    if (row) {
      if (qty === 0) { if (row.parentNode) row.parentNode.removeChild(row); }
      else {
        var span = row.querySelector('.zlc-qty span');
        if (span) span.textContent = qty;
      }
    }

    // Kaarten én voet direct met de geschatte bedragen; server corrigeert zo nodig.
    estimateLines();
    paintPrices();

    var t = totals();
    paintHeader(t.qty);
    if (!t.qty) renderItems();
    renderFooter();

    q.pending[vid] = qty;
    if (q.timer) clearTimeout(q.timer);
    q.timer = setTimeout(pump, qty === 0 ? 0 : 300);
  }

  function pump() {
    if (q.timer) { clearTimeout(q.timer); q.timer = null; }
    if (q.inflight) return;
    var updates = null, k;
    for (k in q.pending) { (updates = updates || {})[k] = q.pending[k]; }
    if (!updates) { if (!hasPending()) paintSync(false); return; }
    q.pending = {};
    q.inflight = true;
    post(CFG.routes.cart + '/update.js', { updates: updates })
      .then(function (c) { if (c && c.items) { q.last = c; q.retried = false; } else { q.dirty = true; } })
      .catch(function () {
        q.dirty = true;
        // Op weg naar de checkout: mislukte batch één keer opnieuw aanbieden.
        if (els.co && els.co.hasAttribute('data-going') && !q.retried) {
          q.retried = true;
          for (var kb in updates) { if (!(kb in q.pending)) q.pending[kb] = updates[kb]; }
        }
      })
      .then(function () {
        q.inflight = false;
        var more = false;
        for (var k2 in q.pending) { more = true; break; }
        if (more || q.timer) { pump(); return; }
        if (q.dirty) {
          q.dirty = false;
          q.reconciling = true;
          readCart().then(function (c2) {
            q.reconciling = false;
            if (c2 && !hasPending()) applyCart(c2);
            if (!hasPending()) paintSync(false);
          });
        } else {
          applyCart(q.last);
          q.last = null;
          paintSync(false);
        }
      });
  }

  // Checkout: openstaande wijzigingen eerst doorduwen (max 4s), dan navigeren.
  function goCheckout() {
    if (els.co.hasAttribute('data-going')) return;
    els.co.setAttribute('data-going', '1');
    els.co.classList.add('zlc-co--wait');
    if (q.timer) { clearTimeout(q.timer); q.timer = null; }
    pump();
    var start = Date.now();
    (function wait() {
      if (!els.co.hasAttribute('data-going')) return;   // bfcache-herstel: loop annuleren
      if (!hasPending() || Date.now() - start > 4000) {
        window.location.href = '/checkout';
        setTimeout(function () {
          els.co.removeAttribute('data-going');
          els.co.classList.remove('zlc-co--wait');
        }, 5000);
        return;
      }
      setTimeout(wait, 80);
    })();
  }

  // ---- vergelijkprijzen (doorgestreept) ------------------------------------

  function fetchCompare() {
    var todo = {};
    (cart.items || []).forEach(function (it) {
      if (it.handle && cmpCache[it.handle] === undefined) todo[it.handle] = 1;
    });
    Object.keys(todo).forEach(function (h) {
      cmpCache[h] = null;
      rawFetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var m = {};
          (p.variants || []).forEach(function (v) {
            if (v.compare_at_price && v.compare_at_price > v.price) m[v.id] = v.compare_at_price;
          });
          cmpCache[h] = m;
          paintPrices();
          renderFooter();
        })
        .catch(function () {});
    });
  }

  // ---- open/dicht ----------------------------------------------------------

  // Staat de thema-lade (toch) open — bv. hersteld uit sessionStorage op desktop, wat de pagina
  // 'samenknijpt' — dan sluiten via de lade zelf: die haalt de squeeze weg, wist de bewaarde
  // stand en geeft zijn scroll-lock vrij. Pas als dat niet kan: attribuut weg + dialog dicht.
  function closeThemeDialog() {
    var host = document.getElementById('cart-drawer');
    if (host && host.hasAttribute('open')) {
      var C = window.customElements && customElements.get('theme-drawer');
      if (C && host instanceof C && typeof host.close === 'function') {
        try { host.close(); } catch (e) { host.removeAttribute('open'); }
      } else {
        host.removeAttribute('open');
      }
    }
    var open = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < open.length; i++) {
      if (isThemeCartDialog(open[i]) && open[i].close) {
        try { open[i].close(); } catch (e) {}
      }
    }
    releaseThemeLock();
  }

  // Horizon 4.x vergrendelt de pagina met lockScroll(owner): een lijst 'eigenaren' in de module
  // @theme/utilities, zichtbaar als html[scroll-lock]. Het attribuut zelf weghalen helpt niet
  // (de module zet het bij de volgende DOM-wijziging terug). Daarom geven we alleen de
  // cart-lade als eigenaar vrij via dezelfde module; een open menu/zoekvenster blijft vergrendeld.
  var utilsP = null;
  function releaseThemeLock() {
    var de = document.documentElement;
    if (!de.hasAttribute('scroll-lock')) return;
    var host = document.getElementById('cart-drawer');
    var panel = host && host.querySelector('dialog');
    if (!panel) return;
    if (!utilsP) {
      try { utilsP = import('@theme/utilities').catch(function () { return null; }); }
      catch (e) { utilsP = Promise.resolve(null); }
    }
    utilsP.then(function (m) {
      if (m && typeof m.unlockScroll === 'function') { m.unlockScroll(panel); return; }
      // Geen module: alleen los als er verder niets vergrendelends open staat.
      if (document.querySelector('dialog[open]:not(#cart-drawer dialog), theme-drawer[open]:not(#cart-drawer), details[scroll-lock][open]')) return;
      de.removeAttribute('scroll-lock');
    });
  }

  function show() {
    closeThemeDialog();
    if (drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    ov.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('zlc-lock');
    document.body.classList.add('zlc-lock');
    setTimeout(function () { try { els.close.focus(); } catch (e) {} }, 60);
  }

  function hide() {
    ov.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('zlc-lock');
    document.body.classList.remove('zlc-lock');
    releaseThemeLock();
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  // ---- events --------------------------------------------------------------

  function cartAction(u) {
    var href = typeof u === 'string' ? u : (u && (u.url || u.href)) || '';
    if (!href) return '';
    var m = String(href).match(/^(?:(?:https?:)?\/\/([^\/]+))?(\/[^ ]*)$/);
    if (!m) return '';
    if (m[1] && m[1] !== location.host) return '';
    var mm = (m[2] || '').match(/^\/cart\/(add|change|update|clear)(?:\.js|\.json)?(?:\?|$)/);
    return mm ? mm[1] : '';
  }

  function bind() {
    ov.addEventListener('click', hide);
    els.close.addEventListener('click', hide);

    // Tab blijft binnen de open drawer (aria-modal zonder trap is een valkuil).
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
      var all = drawer.querySelectorAll('button:not([disabled]), a[href], select, input, [tabindex]:not([tabindex="-1"])');
      var f = [];
      for (var i = 0; i < all.length; i++) {
        if (all[i].offsetParent !== null || all[i] === document.activeElement) f.push(all[i]);
      }
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) hide();
    });

    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-act]');
      if (!btn) return;
      var act = btn.getAttribute('data-act');
      var li = btn.closest('.zlc-li');

      if (act === 'dec' || act === 'inc') {
        var vid = parseInt(li.getAttribute('data-variant'), 10);
        var it = findByVariant(vid);
        if (!it) return;
        optimisticQty(vid, it.quantity + (act === 'inc' ? 1 : -1));
      } else if (act === 'rm') {
        optimisticQty(parseInt(li.getAttribute('data-variant'), 10), 0);
      } else if (act === 'retry') {
        e.preventDefault();
        retryN = 0;
        els.body.innerHTML = '<div class="zlc-empty"><p>Loading your cart&hellip;</p></div>';
        refresh();
      } else if (act === 'checkout') {
        goCheckout();
      }
    });

    document.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
      var trigger = e.target.closest('[data-testid="cart-drawer-trigger"], .cart-bubble, cart-icon-component');
      var link = e.target.closest('a[href]');
      var isCartLink = false;
      if (link) {
        var href = (link.getAttribute('href') || '').split('#')[0];
        isCartLink = /\/cart\/?($|\?)/.test(href);
      }
      if (!trigger && !isCartLink) return;
      if (e.target.closest('#zl-cart-root')) return;
      e.preventDefault();
      e.stopPropagation();
      openNow();
    }, true);

    // Externe cart-mutaties (bijv. de add-to-cart van de PDP) oppikken.
    var prevFetch = window.fetch;
    window.fetch = function () {
      var action = cartAction(arguments[0]);
      var p = prevFetch.apply(this, arguments);
      if (action === 'add') {
        p.then(function (r) { if (r && r.ok) setTimeout(function () { openNow(); }, 10); }, function () {});
      } else if (action) {
        p.then(function (r) { if (r && r.ok) setTimeout(refresh, 10); }, function () {});
      }
      return p;
    };

    document.addEventListener('cart:refresh', function () { refresh(); });
    document.addEventListener('cart:open', function () { openNow(); });

    window.addEventListener('pageshow', function (e) {
      if (els.co) {
        els.co.removeAttribute('data-going');
        els.co.classList.remove('zlc-co--wait');
      }
      if (!e.persisted) return;
      if (q.timer) { clearTimeout(q.timer); q.timer = null; }
      q.pending = {}; q.inflight = false; q.dirty = false; q.last = null; q.reconciling = false; q.retried = false;
      paintSync(false);
      refresh();
    });

    // Vertrekt de gebruiker (link, tab wisselen) binnen het debounce-venster,
    // dan gaan openstaande wijzigingen alsnog direct de deur uit.
    function flushNow() {
      if (q.timer) { clearTimeout(q.timer); q.timer = null; }
      var updates = null, k;
      for (k in q.pending) { (updates = updates || {})[k] = q.pending[k]; }
      if (!updates) return;
      q.pending = {};
      try {
        rawFetch(CFG.routes.cart + '/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          keepalive: true,
          body: JSON.stringify({ updates: updates })
        });
      } catch (e) {}
    }
    window.addEventListener('pagehide', flushNow);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') { flushNow(); return; }
      // Terug op de tab: dim opheffen en de echte cart-stand ophalen.
      if (!hasPending()) { paintSync(false); refresh(); }
    });

    // Vangnet: het thema hertekent zijn header na cart-updates, waarmee on:click terugkomt;
    // en mocht de thema-lade tóch ooit opengaan, meteen weer dicht en de lock los.
    setInterval(function () {
      disarmThemeCartTriggers();
      closeThemeDialog();
      if (!drawer.classList.contains('is-open')) releaseThemeLock();
    }, 1200);
  }

  function init() {
    if (init.did) return;
    init.did = true;
    root = document.getElementById('zl-cart-root');
    if (!root) return;
    ov = $('.zlc-ov');
    drawer = $('.zlc-d');
    els = {
      title: $('.zlc-hd__t'),
      close: $('.zlc-hd__x'),
      note: $('.zlc-note'),
      body: $('.zlc-body'),
      ft: $('.zlc-ft'),
      discRow: $('.zlc-row--disc'),
      discVal: $('.zlc-neg'),
      pills: $('.zlc-pills'),
      totWas: $('.zlc-tot__was'),
      totNow: $('.zlc-tot__now'),
      co: $('.zlc-co')
    };

    els.note.innerHTML = noteHTML();
    els.note.hidden = !TIERS.length;

    var dc = document.querySelector('cart-drawer-component');
    if (dc) dc.removeAttribute('auto-open');
    disarmThemeCartTriggers();
    closeThemeDialog();

    bind();
    refresh();
    window.__ZLCartClean = { open: openNow, close: hide, refresh: refresh };
    window.__ZLCart = window.__ZLCartClean;
    if (openWhenReady) { openWhenReady = false; openNow(); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
